
import { message, Upload } from "antd";
import CryptoJS from 'crypto-js';
import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import store from "../store";
import { setTopHeight } from "../store/reducers/baseInfo";
import {
  CommmonGet,
} from "./network/api";
import qs from "qs";

export function getUserId(): any {
  const state = store.getState();
  const userId = state.userInfo.userId || '';
  return userId;
}

export function getSchoolId(): any {
  const state = store.getState();
  const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const schoolId = params.schoolId || state.schoolInfo.schoolId || '';
  return schoolId;
}

enum WeekDay {
  Sun = "星期日",
  Mon = "星期一",
  Tue = "星期二",
  Wed = "星期三",
  Thu = "星期四",
  Fri = "星期五",
  Sat = "星期六",
}

export const uploadparams = (file: any, type?: any) => {
  return {
    name: file.name,
    chunk: 0,
    chunks: 1,
    type: type,
  };
};

export function CurrentTime(): string {
  let week;
  let data = new Date();
  let year = data.getFullYear();
  let month = data.getUTCMonth() + 1;
  let day = data.getDate();
  let hours = data.getHours();
  let minutes =
    data.getMinutes() < 10 ? "0" + data.getMinutes() : data.getMinutes();
  //let second=data.getSeconds()

  switch (data.getDay()) {
    case 0:
      week = WeekDay.Sun;
      break;
    case 1:
      week = WeekDay.Mon;
      break;
    case 2:
      week = WeekDay.Tue;
      break;
    case 3:
      week = WeekDay.Wed;
      break;
    case 4:
      week = WeekDay.Thu;
      break;
    case 5:
      week = WeekDay.Fri;
      break;
    case 6:
      week = WeekDay.Sat;
      break;
  }

  let currentTime = `${year}-${month}-${day}\xa0\xa0\xa0${week}\xa0${hours}:${minutes}`;
  return currentTime;
}


// 获取系统地址
export const getAddress = async (_userID: any) => {
  let res = await CommmonGet("/system/getSysUrl", { sysId: _userID });
  return res;
};


export const beforeuploadImage = (file: any) => {

  const isImage = file.type.split("/")[0] === "image" ? true : false;
  if (!isImage) {
    message.error("上传文件不是图片格式，请重新上传!");
    return Upload.LIST_IGNORE;
  }
  const isLt2M = file.size / 1024 / 1024 < 20;
  if (!isLt2M) {
    message.error("图片大小不能超过20M!");
  }
  return isImage && isLt2M;
};

const isCnEnNum = (value: string, isupFile?: boolean) => {
  return isupFile
    ? /^[\u4E00-\u9FA5A-Za-z0-9_()[\]\s【】\u300a\u300b@（）*/]+$/.test(value)
    : /^[\u4E00-\u9FA5A-Za-z0-9]+$/.test(value);
};

export const beforeuploadDoc = (file: any) => {
  let type1 = file.name.split(".");
  let type = type1[type1.length - 1];
  let name: string = file.name.substring(0, file.name.length - type.length - 1);
  const isltName = isCnEnNum(name, true) && name.length <= 50;
  if (!isltName) {
    message.error(
      "文件名只能由中文英文数字以及下划线、括号等其它常用基本字符组成，且长度不能超过50个字符"
    );
    return Upload.LIST_IGNORE;
  }
  const isImage = type === "doc" || type === "docx" ? true : false;
  if (!isImage) {
    message.error("上传文件不符合格式要求，请重新上传!");
    return Upload.LIST_IGNORE;
  }
  const isLt2M = file.size / 1024 / 1024 < 10;
  if (!isLt2M) {
    message.error("文件大小不能超过10M!");
    return Upload.LIST_IGNORE;
  }
  return isImage && isLt2M && isltName;
};
export const beforeuploadExcel = (file: any) => {
  let type1 = file.name.split(".");
  let type = type1[type1.length - 1];
  let name: string = file.name.substring(0, file.name.length - type.length - 1);
  const isltName = isCnEnNum(name, true) && name.length <= 50;
  if (!isltName) {
    message.error(
      "文件名只能由中文英文数字以及下划线、括号等基本字符组成，且长度不能超过50个字符"
    );
    return Upload.LIST_IGNORE;
  }
  const isImage = type === "xls" || type === "xlsx" ? true : false;
  if (!isImage) {
    message.error("上传文件不符合格式要求，请重新上传!");
    return Upload.LIST_IGNORE;
  }
  const isLt2M = file.size / 1024 / 1024 < 10;
  if (!isLt2M) {
    message.error("文件大小不能超过10M!");
    return Upload.LIST_IGNORE;
  }

  return isImage && isLt2M && isltName;
};
export const beforeuploadSpecial = (file: any, fileList?: any) => {
  let type1 = file.name.split(".");
  let type = type1[type1.length - 1];
  const ismatch =
    ["doc", "docx", "pdf", "jpg", "jepg", "png", "excel", "xls", "zip"].indexOf(
      type.toLowerCase()
    ) !== -1;
  if (!ismatch) {
    message.error("上传文件不符合格式要求，请重新上传!");
    return Upload.LIST_IGNORE;
  }
  let name: string = file.name.substring(0, file.name.length - type.length - 1);
  const isltName = isCnEnNum(name, true) && name.length <= 50;
  if (!isltName) {
    message.error(
      "文件名只能由中文英文数字以及下划线、括号等基本字符组成，且长度不能超过50个字符"
    );
    return Upload.LIST_IGNORE;
  }
  const isLt2M = file.size / 1024 / 1024 < 10;
  if (!isLt2M) {
    message.error("文件大小不能超过10M!");
    return Upload.LIST_IGNORE;
  }
  const fileNameList = []; //文件名称集合
  fileList.forEach((item) => {
    fileNameList.push(item.name);
  });
  if (fileList.length > 0) {
    let index = fileNameList.indexOf(file.name) !== -1;
    if (index) {
      message.error("不能上传重复文件,请重新上传");
      return Upload.LIST_IGNORE;
    }
  }
  return ismatch && isLt2M && isltName;
};

//判断是否为图片文件
export function isAssetTypeAnImage(ext: string) {
  return (
    ["png", "jpg", "jpeg", "bmp", "gif", "webp", "psd", "svg", "tiff"].indexOf(
      ext.toLowerCase()
    ) !== -1
  );
}

// 中文大写转化
export const toChinesNum = (num: any) => {
  let changeNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  let unit = ["", "十", "百", "千", "万"];
  num = parseInt(num);
  let getWan = (temp: any) => {
    let strArr = temp.toString().split("").reverse();
    let newNum = "";
    for (var i = 0; i < strArr.length; i++) {
      newNum =
        (i === 0 && strArr[i] === 0
          ? ""
          : i > 0 && strArr[i] === 0 && strArr[i - 1] === 0
            ? ""
            : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i])) +
        newNum;
    }
    return newNum;
  };
  let overWan = Math.floor(num / 10000);
  let noWan: any = num % 10000;
  if (noWan.toString().length < 4) {
    noWan = "0" + noWan;
  }
  return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
};

// antd 输入框只允许输入数字和小数点
export const limitNumber = (e: any, banPoint: boolean = false) => {
  const { value } = e.target;
  let value1 = value.length > 1 ? value.replace(/^0+/gi, "") : value;
  value1 = value1 === "" ? "0" : value1.charAt(0) === "." ? "0" + value1 : value1;
  const tempArr = value1.split(".");
  const reg = banPoint ? /[^\d{1,}\d{1,}|\d{1,}]/g : /[^\d{1,}.\d{1,}|\d{1,}]/g;
  if (tempArr[1]?.length) {
    return `${tempArr[0]}.${tempArr[1]}`.replace(reg, "");
  } else {
    return tempArr.length > 2 ? tempArr[0] + "." : value1.replace(reg, "");
  }
};

//防抖
export function debounce(fn: any, delay: number) {
  //定义定时器以便setTimeout
  let timer: any | null = null;
  //返回一个函数，这个函数会在一个时间区间结束后的delay毫秒时执行fn函数
  return function () {
    timer && clearTimeout(timer);
    timer = setTimeout(fn, delay);
  };
}

// 关联下拉菜单
export const dealConfig = (
  fieldConfigList: any,
  fieldList: any,
  curPriority?: number,
  curSelectObj?: any
) => {
  const selectObj: any = curSelectObj ? { ...curSelectObj } : {};
  const fieldNameArr: any = [];
  fieldConfigList.forEach((config: any) => {
    let priority = config.priority;
    // 把前面优先级的 选择项保存下来
    if (priority === 1) {
      selectObj[priority] = fieldList;
    } else {
      // on select change，比优先级低的selectList发生变化
      if (!curPriority || (curPriority && priority > curPriority))
        selectObj[priority] = addPriority(fieldNameArr, fieldList);
    }
    fieldNameArr.push(config.fieldName);
    // 新增操作时
    let len = fieldNameArr.length;
    if (priority && priority === len && fieldNameArr[len - 1] === "") {
      selectObj[priority] = addPriority(fieldNameArr, fieldList);
    }
  });
  return selectObj;
};

// 过滤已选则的filedList
export const addPriority = (fieldNameArr: any, fieldList: any) => {
  let newFieldList = [...fieldList];
  newFieldList = newFieldList.filter((item: any, index: number) => {
    return fieldNameArr.indexOf(item.fieldName) === -1;
  });
  return newFieldList;
};

export const dealSelect = (
  fieldName: string,
  priority: number,
  fieldConfigList: any
) => {
  if (fieldConfigList && fieldConfigList.length === 0) return [];
  let newfieldConfigList = [...fieldConfigList];
  newfieldConfigList.forEach((item: any, index: number) => {
    if (priority === item.priority) item.fieldName = fieldName;
  });
  // 若前面优先级选择了后面的fieldName，那么后面优先级的fieldName置为空
  let len = newfieldConfigList.length;
  for (let i = 0; i < len; i++) {
    // 从左到右
    for (let j = len - 1; j < len && j > i; j--) {
      // 从右到左
      if (newfieldConfigList[i].fieldName === newfieldConfigList[j].fieldName) {
        // todo list 这里虽然fieldName置为空了，但是select上还有默认显示的原始值
        newfieldConfigList[j].fieldName = "";
      }
    }
  }
  //   console.log('newfieldConfigList', newfieldConfigList);
  return newfieldConfigList;
};

// 校验相关
export const keyPureMath = (event: any, extra?: any[]) => {
  console.log(event.key);
  let invalid = ["+", "e", "E", "`"];
  if (extra) {
    invalid = ["+", "e", "E", ...extra];
  }
  if (invalid.findIndex((item) => item === event.key) !== -1) {
    event.preventDefault();
  }
};

export const keyNumEn = (event: any) => {
  let reg = /[\W]/g;
  if (reg.test(event.key)) {
    event.preventDefault();
  }
};

export const keyNum = (event: any) => {
  let reg = /[^\d]/g;
  if (reg.test(event.key)) {
    event.preventDefault();
  }
};

// 输入数字
export const handleKeyPress = (event) => {
  const keyCode = event.which || event.keyCode; // 兼容不同浏览器获取按键码的方式
  // 允许的按键码：48-57 是数字键的按键码
  if (keyCode < 48 || keyCode > 57) {
    event.preventDefault(); // 阻止默认行为（即不允许输入）
  }
}

// 身份证校验
export const CheckIdCard = (idNumber: string) => {
  // 地区码校验
  // var provinceCode = idNumber.substring(0, 2);
  // 在此处添加你的地区码校验逻辑
  // 可以使用一个地区码表来进行验证

  // 长度校验
  if (idNumber.length !== 15 && idNumber.length !== 18) {
    return '身份证格式有误';
  }

  // 格式校验
  var regex15 = /^\d{15}$/;
  var regex18 = /(^\d{17}(\d|X|x)$)/;
  if (!(regex15.test(idNumber) || regex18.test(idNumber))) {
    return '身份证格式有误';
  }

  // 生日校验
  var birthday;
  if (idNumber.length === 15) {
    birthday = "19" + idNumber.slice(6, 12);
  } else {
    birthday = idNumber.slice(6, 14);
  }
  var year = parseInt(birthday.slice(0, 4));
  var month = parseInt(birthday.slice(4, 6));
  var day = parseInt(birthday.slice(6, 8));
  if (month > 12 || month < 1 || day > 31 || day < 1) {
    return '身份证日期格式有误';
  }
  var leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  var maxDays = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (day > maxDays[month - 1]) {
    return '身份证日期格式有误';
  }

  // 校验位计算
  if (idNumber.length === 18) {
    var weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var checkCode = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    for (var i = 0; i < 17; i++) {
      sum += parseInt(idNumber.charAt(i)) * weight[i];
    }
    var mod = sum % 11;
    if (idNumber.charAt(17) !== checkCode[mod].toString()) {
      return '身份证编码规则有误';
    }
  }
  // 校验通过
  return '';
}

// 手机号校验
export const CheckPhone = (value: string) => {
  let reg = /^1[3456789]\d{9}$/;
  //   let reg1 = /^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$/;
  let reg1 = /0\d{2,3}-\d{4,8}/;
  return !(
    value.length > 0 &&
    reg.test(value) === false &&
    reg1.test(value) === false
  );
};

export const CheckEmail = (value: string) => {
  let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return !(value.length > 0 && reg.test(value) === false);
};
//QQ校验
export function isQQ(code) {
  return (/[1-9][0-9]{4,}/).test(code)
}

export function iswechat(code) {
  return (/^[a-zA-Z][a-zA-Z\d_-]{5,19}$/).test(code)
}

// 中文替换字符
export const replyCN = (event: any) => {
  return event.target.value.replace(/[\u4E00-\u9FA5]/g, "");
};

// 只允许输入数字
export const replyNum = (event: any) => {
  console.log(event.target.value.replace(/[^\d]/g, ""));
  return event.target.value.replace(/[^\d]/g, "");
};

// 下载流相关
const saver = (blob, filename) => {
  var URL = window.URL || window.webkitURL;
  var protocol = window.location.protocol;
  var type = blob.type;
  var force_saveable_type = "application/octet-stream";
  if (type && type !== force_saveable_type) {
    // 强制下载，而非在浏览器中打开
    var slice = blob.slice || blob.webkitSlice || blob.mozSlice;
    blob = slice.call(blob, 0, blob.size, force_saveable_type);
  }
  var url = URL.createObjectURL(blob);

  var save_link: any = document.createElementNS(
    protocol + "//www.w3.org/1999/xhtml",
    "a"
  );
  save_link = document.createElement('a'); // 修改这里，使用普通的 a 标签
  save_link.href = url;

  save_link.download = filename;

  // var event = new MouseEvent("click", {
  //   bubbles: true,
  //   cancelable: true,
  //   view: window,
  // });
  // save_link.dispatchEvent(event);
  // URL.revokeObjectURL(url);  

  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (this.status === 200) {
      var blob = this.response;
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        var base64data = reader.result;
        save_link.href = base64data;
        // save_link.dispatchEvent(event);
        document.body.appendChild(save_link); // 添加到 DOM 中以便于模拟点击
        save_link.click(); // 模拟点击事件
        document.body.removeChild(save_link); // 下载完成后再移除下载链接
        URL.revokeObjectURL(url);
      }
    }
  };
  xhr.send();
};

export const saveAs = (url: any, filename: any) => {
  var oReq = new XMLHttpRequest();
  // The Endpoint of your server
  var URLToPDF = url;
  //console.log(decodeURIComponent(0226c71868c04a86abd869fdd5b7c244))
  // Configure XMLHttpRequest
  oReq.open("GET", URLToPDF, true);

  // Important to use the blob response type
  oReq.responseType = "blob";
  // When the file request finishes
  // Is up to you, the configuration for error events etc.
  oReq.onload = function () {
    // Once the file is downloaded, open a new window with the PDF
    // Remember to allow the POP-UPS in your browser
    var file = new Blob([oReq.response], {
      type: "application/pdf",
    });
    // Generate file download directly in the browser !
    var blob = new Blob([file], { type: "text/plain" });
    saver(blob, filename);
  };

  oReq.send();
};

// 图片下载
//下载图片
export function downloadIamge(imgsrc, name) {
  //下载图片地址和图片名
  var image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    let cwindow: any = window.navigator;
    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    var a = document.createElement("a"); // 生成一个a元素
    if (typeof MouseEvent !== "function") {
      if (cwindow.msSaveBlob) {
        // console.log(123);
        var bstr = atob(url.split(",")[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var blob = new Blob([u8arr]);
        cwindow.msSaveBlob(blob, name);
        // window.open(url)
      } else {
        message.warning("您的浏览器版本过低，请升级至最新版或更换其它浏览器");
      }
    } else {
      var event = new MouseEvent("click"); // 创建一个单击事件
      a.download = name || "photo"; // 设置图片名称
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
    }
  };
  image.src = imgsrc;
}

// 文件流下载
export const downLoadDataQuery = (res: any, fileName: string) => {
  const url = window.URL.createObjectURL(
    new Blob([res], {
      type: "text/csv,charset=UTF-8",
    })
  );
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  // let downName='缴费名单'
  link.setAttribute("download", decodeURI(fileName));
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// 判断两个对象的内容是否相等
export function isObjectValueEqual(a, b) {
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);
  if (aProps.length !== bProps.length) {
    return false;
  }
  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];

    var propA = a[propName];
    var propB = b[propName];
    // 2020-11-18更新，这里忽略了值为undefined的情况
    // 故先判断两边都有相同键名
    if (!b.hasOwnProperty(propName)) return false;
    if (propA instanceof Object) {
      if (isObjectValueEqual(propA, propB)) {
        // return true     这里不能return ,后面的对象还没判断
      } else {
        return false;
      }
    } else if (propA !== propB) {
      return false;
    } else {
    }
  }
  return true;
}

// 下载url
export function DownloadUrl(file) {
  // 音视频下载
  if (file.url.indexOf("http://") >= 0 || file.url.indexOf("https://") >= 0) {
    let handleUrl = file.url;
    //   if (location.protocol === 'https:') {
    //     handleUrl = file.url.replace('http://', 'https://')
    //   } else {
    //     handleUrl = file.url
    //   }
    var xhr = new XMLHttpRequest();
    xhr.open("GET", handleUrl, true);
    xhr.responseType = "blob";
    xhr.onload = function (e: any) {
      if (e.target.readyState === 4 && e.target.status === 200) {
        let blob = this.response;
        // 转换一个blob链接
        let u = window.URL.createObjectURL(new Blob([blob]));
        let a = document.createElement("a");
        a.download = file.fileName;
        a.href = u;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    };
    xhr.send();
  }
}

// 文件列表
export function ShowFileList(type?: any) {
  return {
    //   预览图标
    showPreviewIcon: true,
    // 移除图标
    showRemoveIcon: true,
    // 下载图标
    showDownloadIcon: true,
  };
}

//图片转base64位
export function getBase64(img, callback) {
  const reader = new FileReader();
  reader.readAsDataURL(img);
  return new Promise(function (resolve) {
    reader.addEventListener("load", () => callback(resolve(reader.result)));
  });
}

//校验url是否是合法http（s）
export function checkURL(URL) {
  var str = URL;
  //判断URL地址的正则表达式为:http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?
  //下面的代码中应用了转义字符"\"输出一个字符"/"
  var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/;
  var objExp = new RegExp(Expression);
  if (objExp.test(str) === true) {
    return true;
  } else {
    return false;
  }
}



// 查找字符串以及位置
export function findstr(str, cha, num) {
  var x = str.indexOf(cha);
  for (var i = 0; i < num; i++) {
    x = str.indexOf(cha, x + 1);
  }
  return x;
}

// 精确到秒
export const spliceSecond = (str: string) => {
  return str.substring(0, str.lastIndexOf(":"));
};

// message唯一弹出
export const AntDMessage = (info: string, type?: string) => {
  message.destroy();
  if (type) {
    message[type](info);
  } else {
    message.warning(info);
  }
};

declare var listenAppDurationTime: any;

//调用大数据接口
export const setDataUrl = async (_userID: any) => {
  let res: any = await CommmonGet("/system/getSysUrl", { sysId: "860" }).catch(
    (error: any) => {
      console.log(error);
    }
  );
  console.log(res);

  if (res) {
    let res1: any = await CommmonGet("/system/getSysUrl", {
      sysId: "850",
    }).catch((error: any) => {
      console.log(error);
    });
    if (res1) {
      let script = document.createElement("script");
      script.async = true;
      script.src = res + "bigData/Common/listen_app_duration_time.js";
      script.onload = function () {
        listenAppDurationTime(res1, "T11", "T11001", _userID);
      };
      document.body.appendChild(script);
    }
  } else {
    return true;
  }
};

// 预览
export const preview = (file: any) => {
  if (file.response && file.response.status === 0) {
    window.open(file.response.data.preUrl);
  } else {
    if (file.status === "done" && file.url) {
      window.open(file.url);
    } else {
      return;
    }
  }
};

// 页数计算
export const totalPage = (count: number, pageNum: number) => {
  let baseRes = count === 0 ? count + 1 : count;
  let whole = Math.trunc(baseRes / pageNum);
  let decimal = baseRes / pageNum - whole;
  console.log(whole + (decimal > 0 ? 1 : 0));

  return whole + (decimal > 0 ? 1 : 0);
};

// 富文本表格处理
export const getTableInfo = (value) => {
  let th = '<th style="background-color: #f1f1f1; font-weight: bold; border: 1px solid black;text-align: center;">';
  const modifiedString = value.replace(/<table border="0" width="100%" cellpadding="0" cellspacing="0">/g, '<table style="border: 1px solid black; border-collapse: collapse;"  border="0" width="100%" cellpadding="0" cellspacing="0">');
  let finalString = modifiedString.replace(/<th>/g, th);
  finalString = finalString.replace(/<th style="border-top: 1px solid black; border-bottom-width: 1px; border-left: 1px solid black; border-right-color: black; border-bottom-color: black; border-image: initial;">/g, th)
  const trString = finalString.replace(/<tr>/g, '<tr style="height: 22px;">');
  const withTdBorders = trString.replace(/<td>/g, '<td style="border: 1px solid black;">');
  return withTdBorders
}

const secretKey = `${process.env.REACT_APP_SYSTERM_ID}_YourSecretKey`;

// 加密
export function encryptData(data) {
  const encryptedData = CryptoJS.AES.encrypt(data, secretKey).toString();
  return encryptedData;
}

// 解密
export function decryptData(encryptedData) {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedData;
}
// 详情页面处理
export const useTopHeight96 = () => {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(setTopHeight(96));
    return () => {
      dispatch(setTopHeight(128));
    }
  }, []);
};

// 修改日期格式：2023-1-1"改成两位数"2023-01-01"
export function formatDateString(dateStr) {
  var parts = dateStr.split("-");
  var formattedMonth = parts[1].length === 1 ? "0" + parts[1] : parts[1];
  var formattedDay = parts[2].length === 1 ? "0" + parts[2] : parts[2];
  return parts[0] + "-" + formattedMonth + "-" + formattedDay;
};
// 日期格式处理
export function formatDate(dateString: string, format: string): string {
  const date = new Date(dateString);
  const map: { [key: string]: string } = {
    "yyyy": date.getFullYear().toString(),
    "MM": ('0' + (date.getMonth() + 1)).slice(-2),
    "dd": ('0' + date.getDate()).slice(-2),
    "HH": ('0' + date.getHours()).slice(-2),
    "mm": ('0' + date.getMinutes()).slice(-2),
    "ss": ('0' + date.getSeconds()).slice(-2)
  };

  return format.replace(/yyyy|MM|dd|HH|mm|ss/gi, matched => map[matched]);
}
// 去掉HTML标签
export function removeTags(str) {
  return str.replace(/<[^>]*>/g, '');
}

// 获取表单的所有字段值并进行修剪操作，然后重新设置回表单
export const trimFormValues = (form) => {
  const values = form.getFieldsValue(); // 获取当前表单的所有字段值
  // const trimmedValues = trimValues(values); // 修剪所有字符串值
  let trimmedValues = {};
  for (let key in values) {
    if (values.hasOwnProperty(key) && typeof values[key] === 'string') {
      trimmedValues[key] = values[key].trim();
    } else {
      trimmedValues[key] = values[key];
    }
  }

  form.setFieldsValue(trimmedValues); // 将修剪后的值设置回表单
};
